import { render } from "./ReviewStars.vue?vue&type=template&id=47bd1210"
import script from "./ReviewStars.vue?vue&type=script&lang=js"
export * from "./ReviewStars.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__